<template>
  <v-list three-line ripple class="facilities-list">
    <template v-for="(item, index) in items">
      <v-list-item :key="item.id">
        <v-list-item-icon>
          <div class="list-item-index">
            {{ index + 1 }}
          </div>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="d-flex align-center">
            {{ item.name }}
            <v-tooltip bottom v-if="isAreaFacility(item)">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="ml-1">
                  <v-icon size="18" color="text-muted">mdi-information</v-icon>
                </span>
              </template>
              <span>{{ $t("message.common.areaFacility") }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ item.formatted_address }}
          </v-list-item-subtitle>
          <div class="list-item-value">
            <slot v-bind="item"></slot>
          </div>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { BUSINESS_TYPE } from "@/enums/business-type.enum";
export default {
  name: "DashboardFacilitiesList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isAreaFacility(item) {
      return item.business_type === BUSINESS_TYPE.AREA;
    }
  }
};
</script>

<style lang="scss" scoped>
.facilities-list {
  max-height: 100%;
  max-width: 330px;
  margin-left: $spacing * 4;
  overflow-y: auto;
  padding: 0;

  .v-list-item {
    &:first-of-type {
      border-top: 1px solid rgba($dark, 0.05);
    }
    border-bottom: 1px solid rgba($dark, 0.05);
  }

  .v-list-item__content {
    align-self: center;
  }

  .v-list-item__title,
  .v-list-item__subtitle {
    @include font-size(14px);
    color: $text;
    line-height: 17px;
  }

  .v-list-item__title {
    font-weight: 500;
  }

  .v-list-item__subtitle {
    font-weight: normal;
  }

  .v-list-item__icon {
    margin: $spacing * 1.5 $spacing * 1.5 0 0;
  }

  .list-item-index {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: $dashboard-positive-color;
    border: 1px solid $dashboard-positive-color;
  }

  .list-item-value {
    margin-top: $spacing / 2;
  }
}
</style>
